import { urls } from "../config/urls.prod"
import { AppEnvironment } from "@puntaje/shared/core"

export const environment: AppEnvironment = {
    production: true,
    endpoints: {
        base: urls.baseUrl,
        nebulosa: urls.nebuUrl,
        achievements: urls.achievementsUrl,
        carreras: urls.carrerasUrl
    },
    googleAnalyticsPropertyId: {
        alumnos: "UA-51752657-1"
    },
    globalSiteTag: {
        alumnos: {
            propertyId: "G-9ZDEXZHP6F"
        },
        profesores: {
            propertyId: "G-ZM11JTDKWR"
        }
    },
    domain: {
        profesores: "docentes.aprendemas.ogr.cl",
        alumnos: "www.aprendemas.ogr.cl",
        admin: "admin.aprendemas.ogr.cl"
    },
    facebookAnalyticsPropertyId: {},
    facebook: {
        appId: null,
        apiVersion: null
    }
}

export const oldEnvironment = {
    production: true,
    baseUrl: urls.baseUrl,
    nebuUrl: urls.nebuUrl,
    achievementsUrl: urls.achievementsUrl,
    facebookAppId: null,
    facebookApiVersion: null,
    domain: {
        profesores: "docentes.aprendemas.ogr.cl",
        alumnos: "www.aprendemas.ogr.cl",
        admin: "admin.aprendemas.ogr.cl"
    }
}
